// extracted by mini-css-extract-plugin
module.exports = {"tabTitle":"TabTitle_tabTitle__nvLhK","isSelected":"TabTitle_isSelected__3e4vd"};